import styled from 'styled-components';

import FieldEntryWrapper from '../../../../../../components/FieldEntryWrapper/FieldEntryWrapper';

const PostalAddressField = styled(FieldEntryWrapper)`
    margin: 0;
    padding: 0 20px 20px 0;
`;

const PostalAddressFieldSmall = styled(PostalAddressField)`
    width: calc(50% / 3);
    flex: 0 0 calc(50% / 3);

    @media only screen and (max-width: 1450px) {
        width: calc(100% / 3);
        flex: 0 0 calc(100% / 3);
    }
`;

const PostalAddressFieldHalf = styled(PostalAddressField)`
    width: 50%;
    flex: 0 0 50%;

    @media only screen and (max-width: 1450px) {
        width: 100%;
        flex: 0 0 100%;
    }
`;

const PostalAddressFieldFull = styled(PostalAddressField)`
    width: 100%;
    flex: 0 0 100%;
`;

export default {
    Small: PostalAddressFieldSmall,
    Halfwidth: PostalAddressFieldHalf,
    Fullwidth: PostalAddressFieldFull,
};
